/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type { BrandingGenerateRequest, BrandingGenerateResponse } from '../types/BrandingGenerate'

/**
 * POST /brandings/generate
 * @see backend/nexus/modules/Branding/Http/Controllers/BrandingController.php BrandingController::generate
 */
export async function brandingGenerate(
	data: BrandingGenerateRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<BrandingGenerateResponse>> {
	return axiosInstance.post('/brandings/generate', data, config)
}
